
import { ErrorBoundary, LayoutRouter } from "@intrasync/react";
import React from 'react';

const App: React.FC = () => {
  return (
    <ErrorBoundary isLayout name="LayoutRouter">
      <LayoutRouter />
    </ErrorBoundary>
  );
};

export default App;
